<div class="tab-pane" role="tabpanel" id="proysrdom">
    <fieldset id="agregar_proysrdom" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal">
                            <div class="form-group" align="left" style="padding-top: 20px;">
                                <div class="col-sm-3">
                                    <label for="dproy">Datos del Proyecto:</label>
                                </div>
                                <div class="col-sm-8">
                                    <mat-radio-group formControlName="datos" (change)="add_datos_proyecto()">
                                        <div class="col-sm-5">
                                            <mat-radio-button style="padding-right: 20px" name="datos" value="SI">CONSIDERA CAMBIO DE DESTINO</mat-radio-button>
                                        </div>
                                        <div class="col-md-1"></div>
                                        <div class="col-sm-3">
                                            <mat-radio-button style="padding-right: 20px" name="datos" value="NO">GENERA NUEVAS UNIDADES</mat-radio-button>
                                        </div>
                                    </mat-radio-group>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>